var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEyes(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.849,
    height: 19.28,
    viewBox: "0 0 30.849 19.28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_metro-eye",
    "data-name": "Icon metro-eye",
    d: "M17.995,7.712a17.276,17.276,0,0,0-15.424,9.64,17.159,17.159,0,0,0,30.849,0,17.276,17.276,0,0,0-15.424-9.64ZM25.6,12.825a14.668,14.668,0,0,1,4.5,4.528,14.668,14.668,0,0,1-4.5,4.528,14.135,14.135,0,0,1-15.21,0,14.668,14.668,0,0,1-4.5-4.528,14.668,14.668,0,0,1,4.5-4.528c.118-.075.237-.148.357-.22a7.712,7.712,0,1,0,14.5,0q.18.107.357.22ZM17.995,14.46A2.892,2.892,0,1,1,15.1,11.568,2.892,2.892,0,0,1,17.995,14.46Z",
    transform: "translate(-2.571 -7.712)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyes);
export default __webpack_public_path__ + "static/media/eyes.1bec1aef40ddf030cb02486a95d7c021.svg";
export { ForwardRef as ReactComponent };